// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image
// } from "@react-pdf/renderer";

// import PdfSecondPage from "./SecondImagePdf";
// import TechSpecs from "./TechSpecs";
// import TermsConditions from "./TermsandConditions";




// // Example image imports (replace with your actual files)
// import logo from "../images/Helix logo.jpg";
// import product1 from "../images/product1.jpg";
// import product2 from "../images/product2.jpg";
// import product3 from "../images/product3.jpg";

// // Sketch background images
// import sketch1 from "../images/sketch1.jpg";
// import sketch2 from "../images/sketch2.jpg";
// import sketch3 from "../images/sketch3.jpg";

// // Social media icons
// import instagram from "../images/instagram.jpeg";
// import youtube from "../images/youtube.png";
// import linkedin from "../images/web.jpeg";
// import BankDetailsPage from "./BankDetail";

// const Pdf2 = () => (
//   <Document>
//     <Page size="A4" style={styles.page}>
//       {/* Foreground Content */}
//       <View style={styles.content}>
//         {/* Header */}
//         <View style={styles.header}>
//           <Image src={logo} style={styles.logo} />
//           <View style={styles.headerRight}>
//             <Text style={styles.contact}>+91 8827559628 | info@sbsgroups.co.in</Text>
//             <Text style={styles.contact}>+91 9826808412 | sales@sbsgroups.co.in</Text>
//           </View>
//         </View>


//         {/* Quotation Table */}
// <View style={styles.tableContainer}>
//   <View style={styles.table}>
//     <View style={styles.tableRowHeader}>
//       <Text style={styles.tableHeaderText}>
//         Quotation for {initialQuotations.products[0]?.modelNo || "Product"}
//       </Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Kindly attend to:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.name}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Contact No:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.contact}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Company Name:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.company}, {initialQuotations.customer.address}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Email Id:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.email || "-"}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>GSTIN No:</Text>
//       <Text style={styles.value}>{initialQuotations.customer.gstin}</Text>
//     </View>

//     <View style={styles.tableRow}>
//       <Text style={styles.label}>Quo Ref No:</Text>
//       <Text style={styles.value}>{initialQuotations.quotationId}</Text>
//     </View>

//     {/* <View style={styles.tableRow}>
//       <Text style={styles.label}>Quotation Date:</Text>
//       <Text style={styles.value}>{initialQuotations.quotationDate}</Text>
//     </View> */}
//   </View>
// </View>


//         {/* Sketches in a row */}
//         <View style={styles.sketchesRow}>
//           <Image src={sketch1} style={styles.sketchImage} />
//           <Image src={sketch2} style={styles.sketchImage} />
//           <Image src={sketch3} style={styles.sketchImage} />
//         </View>

//         {/* Product Images */}
//         <View style={styles.imagesRow}>
//           <Image src={product1} style={styles.productImage} />
//           <Image src={product2} style={styles.productImage} />
//           <Image src={product3} style={styles.productImage} />
//         </View>

//         {/* Footer (flow content, not absolute) */}
//         <View style={styles.footer}>
//           <Text style={styles.footerTitle}>MODERN SOLUTION FOR HANDLING</Text>

//           <View style={styles.socialRow}>
//             <Image src={instagram} style={styles.icon} />
//             <Text style={styles.socialText}>helixengineers</Text>
//             <Image src={youtube} style={styles.icon} />
//             <Text style={styles.socialText}>HelixEngineers</Text>
//             <Image src={linkedin} style={styles.icon} />
//             <Text style={styles.socialText}>sbsgroups.co.in</Text>
//           </View>

//           <View style={styles.addressBar}>
//             <Text style={styles.footerAddress}>
//               Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
//             </Text>
//           </View>
//         </View>
//       </View>
//     </Page>
//      {/* Second Page */}
//      <PdfSecondPage />
//      {/* Third Page */}



// {initialQuotations.products.map((p, idx) => (
//   <TechSpecs key={p.id || idx} product={p} />
// ))}

// <TermsConditions products={initialQuotations} />

//      {/* Fourth Page */}
//      {/* <TermsConditions /> */}
//      {/* Fifth Page */}
//     <BankDetailsPage
//   bankDetails={initialQuotations.bankDetails}
//   legalCerts={initialQuotations.legalCerts}
//   preparedBy={initialQuotations.preparedBy}
//    regards={initialQuotations.regards}
// />


//   </Document>
// );

// const styles = StyleSheet.create({
//   page: {
//     padding: 20,
//     fontSize: 10,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff"
//   },
//   content: {
//     flexDirection: "column"
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: 15
//   },
//   logo: {
//     width: 100,
//     height: 50
//   },
//   headerRight: {
//     flexDirection: "column",
//     alignItems: "flex-end"
//   },
//   contact: {
//     fontSize: 9
//   },
//   tableContainer: {
//     width: "50%", // table occupies 50% width
//     marginBottom: 20
//   },
//   table: {
//     border: "1pt solid #000"
//   },
//   tableRowHeader: {
//     backgroundColor: "#000",
//     padding: 5
//   },
//   tableHeaderText: {
//     color: "#fff",
//     fontSize: 11,
//     fontWeight: "bold"
//   },
//   tableRow: {
//     flexDirection: "row",
//     borderTop: "1pt solid #000",
//     padding: 5
//   },
//   label: {
//     width: "30%",
//     fontWeight: "bold"
//   },
//   value: {
//     width: "70%"
//   },
//   sketchesRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginVertical: 20
//   },
//   sketchImage: {
//     width: 120,
//     height: 100,
//     opacity: 2
//   },
//   imagesRow: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     marginVertical: 30 // ✅ extra space before footer
//   },
//   productImage: {
//     width: 180,
//     height: 250,
//     objectFit: "contain"
//   },
//   footer: {
//     marginTop: 20, // ✅ keeps footer away from images
//     textAlign: "center"
//   },
//   footerTitle: {
//     fontSize: 12,
//     fontWeight: "bold",
//     marginBottom: 10
//   },
//   socialRow: {
//     flexDirection: "row",
//     justifyContent: "center",
//     alignItems: "center",
//     marginBottom: 8
//   },
//   icon: {
//     width: 14,
//     height: 14,
//     marginHorizontal: 4
//   },
//   socialText: {
//     fontSize: 9,
//     marginRight: 10
//   },
//   addressBar: {
//     backgroundColor: "#222",
//     padding: 5,
//     marginTop: 5
//   },
//   footerAddress: {
//     fontSize: 9,
//     color: "#fff"
//   }
// });

// export default Pdf2;


import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";

import PdfSecondPage from "./SecondImagePdf";
import TechSpecs from "./TechSpecs";
import TermsConditions from "./TermsandConditions";
import BankDetailsPage from "./BankDetail";

// Images
import logo from "../../../../images/Final-logo-SBS.png"
import product1 from "../../images/product1.jpg";
import product2 from "../../images/product2.jpg";
import product3 from "../../images/product3.jpg";
import sketch1 from "../../images/sketch1.jpg";
import sketch2 from "../../images/sketch2.jpg";
import sketch3 from "../../images/sketch3.jpg";
import instagram from "../../images/instagram.jpeg";
import youtube from "../../images/youtube.png";
import linkedin from "../../images/web.jpeg";

const Pdf2 = ({ leadInfo, quotation }) => {
  console.log("PDF2 - leadInfo:", leadInfo);
  console.log("PDF2 - quotation:", quotation);

  // Safely access products with fallback
  const products = quotation?.products || [];
// At the top of your Pdf2.js
const receiver =
  quotation?.receiver_details
    ? typeof quotation.receiver_details === "string"
      ? JSON.parse(quotation.receiver_details)
      : quotation.receiver_details
    : {};

const regards =
  quotation?.regard_details
    ? typeof quotation.regard_details === "string"
      ? JSON.parse(quotation.regard_details)
      : quotation.regard_details
    : {};

const company =
  quotation?.company_details
    ? typeof quotation.company_details === "string"
      ? JSON.parse(quotation.company_details)
      : quotation.company_details
    : {};

  const firstProduct = products[0] || {};

  return (
    <Document>
      {/* First Page - Main Quotation */}
      <Page size="A4" style={styles.page}>
        <View style={styles.content}>
          {/* Header */}
          <View style={styles.header}>
            <Image src={logo} style={styles.logo} />
            <View style={styles.headerRight}>
              <Text style={styles.contact}>+91 8827559628 | info@sbsgroups.co.in</Text>
              <Text style={styles.contact}>+91 9826808412 | sales@sbsgroups.co.in</Text>
            </View>
          </View>

          {/* Quotation Table */}
          <View style={styles.tableContainer}>
            <View style={styles.table}>
              <View style={styles.tableRowHeader}>
                <Text style={styles.tableHeaderText}>Quotation for Automatic Pin Conveyor</Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.label}>Kindly attend to:</Text>
                <Text style={styles.value}>{receiver.lead_name || "N/A"}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.label}>Contact No:</Text>
                <Text style={styles.value}>{receiver.contact_number || "N/A"}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.label}>Company Name:</Text>
                <Text style={styles.value}>{receiver.business_name || "N/A"}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.label}>Email Id:</Text>
                <Text style={styles.value}>{receiver.email || "N/A"}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.label}>GSTIN No:</Text>
                <Text style={styles.value}>{receiver.gstin_lead || "N/A"}</Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.label}>Quo Ref No:</Text>
                <Text style={styles.value}>{quotation.quotation_number}</Text>
              </View>
            </View>
          </View>

          {/* Sketches */}
          <View style={styles.sketchesRow}>
            <Image src={sketch1} style={styles.sketchImage} />
            <Image src={sketch2} style={styles.sketchImage} />
            <Image src={sketch3} style={styles.sketchImage} />
          </View>

          {/* Product Images */}
          <View style={styles.imagesRow}>
            <Image src={product1} style={styles.productImage} />
            <Image src={product2} style={styles.productImage} />
            <Image src={product3} style={styles.productImage} />
          </View>

          {/* Footer */}
          <View style={styles.footer}>
            <Text style={styles.footerTitle}>MODERN SOLUTION FOR HANDLING</Text>
            <View style={styles.socialRow}>
              <Image src={instagram} style={styles.icon} />
              <Text style={styles.socialText}>helixengineers</Text>
              <Image src={youtube} style={styles.icon} />
              <Text style={styles.socialText}>HelixEngineers</Text>
              <Image src={linkedin} style={styles.icon} />
              <Text style={styles.socialText}>sbsgroups.co.in</Text>
            </View>
            <View style={styles.addressBar}>
              <Text style={styles.footerAddress}>
                Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
              </Text>
            </View>
          </View>
        </View>
      </Page>

      {/* Second Page */}
      <PdfSecondPage quotation={quotation} />

      {/* Technical Specifications Page(s) - Pass products array */}
      <TechSpecs products={products} />

      {/* Terms & Conditions */}
      <TermsConditions leadInfo={leadInfo} quotation={quotation} products={products}  />

      {/* Bank Details */}
      <BankDetailsPage  company={company} regards={regards}/>
    </Document>
  );
};

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
    backgroundColor: "#fff"
  },
  content: {
    flexDirection: "column"
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15
  },
  logo: {
    width: 100,
    height: 50
  },
  headerRight: {
    flexDirection: "column",
    alignItems: "flex-end"
  },
  contact: {
    fontSize: 9
  },
  tableContainer: {
    width: "60%",
    marginBottom: 20
  },
  table: {
    border: "1pt solid #000"
  },
  tableRowHeader: {
    backgroundColor: "#000",
    padding: 5
  },
  tableHeaderText: {
    color: "#fff",
    fontSize: 11,
    fontWeight: "bold"
  },
  tableRow: {
    flexDirection: "row",
    borderTop: "1pt solid #000",
    padding: 5
  },
  label: {
    width: "35%",
    fontWeight: "bold"
  },
  value: {
    width: "65%"
  },
  sketchesRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 20
  },
  sketchImage: {
    width: 120,
    height: 100
  },
  imagesRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 30
  },
  productImage: {
    width: 180,
    height: 250,
    objectFit: "contain"
  },
  footer: {
    marginTop: 20,
    textAlign: "center"
  },
  footerTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 10
  },
  socialRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 8
  },
  icon: {
    width: 14,
    height: 14,
    marginHorizontal: 4
  },
  socialText: {
    fontSize: 9,
    marginRight: 10
  },
  addressBar: {
    backgroundColor: "#222",
    padding: 5,
    marginTop: 5
  },
  footerAddress: {
    fontSize: 9,
    color: "#fff"
  }
});

export default Pdf2;